import { getVehicleTypeFunction } from '@/common/queries/selections/vehicleType/vehicleTypeFunction';
import { queryOptions } from '@tanstack/react-query';

export const getVehicleTypeOption = () =>
  queryOptions({
    queryKey: ['get_vehicle_type'],
    queryFn: () => getVehicleTypeFunction(),
  });
